/**
 * White-label branding configuration.
 *
 * Co-branded demo: Ping Group (operator) × Thompson Aero Seating (manufacturer),
 * powered by ubloquity. The white-label badge in the sidebar and public passport
 * footer is shown automatically because companyName !== "ubloquity".
 */

export interface BrandConfig {
  platformName: string
  companyName: string
  /** Showcased manufacturer (rendered alongside the operator wordmark). */
  partnerName: string
  logoUrl: string
  partnerLogoUrl?: string
  primaryColour: string
  accentColour: string
  darkColour: string
  contactUrl?: string
  partnerContactUrl?: string
  /** Automatically set: true when companyName !== "ubloquity" */
  isWhiteLabel: boolean
}

// Widen to plain string so the isWhiteLabel check below isn't narrowed away by TS.
const companyName: string = 'Ping Group'

export const branding: BrandConfig = {
  platformName: 'Ping Group DPP',
  companyName,
  partnerName: 'Thompson Aero Seating',
  logoUrl: 'ping-logo.png',
  partnerLogoUrl: 'thompson-aero-logo.png',
  // Ping Group corporate blue (sampled from pinggroup.co.uk) with Thompson Aero red as accent.
  primaryColour: '#0A4A8F',
  accentColour: '#C8102E',
  darkColour: '#062E5C',
  contactUrl: 'https://www.pinggroup.co.uk',
  partnerContactUrl: 'https://www.thompsonaero.com',
  isWhiteLabel: companyName !== 'ubloquity',
}
